<div class="h-xl-100">
  <div class="card-body">
    <div class="d-flex flex-stack">
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <h1
          class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-1"
        >
          {{ "APP.PASSWORD_MANAGEMENT" | translate }}
        </h1>
        <span class="text-muted fs-7">{{
          "APP.CHANGE_RESET_PASSWORD" | translate
        }}</span>
      </div>
      <div class="d-flex align-items-center gap-4">
        <!-- <button
          class="btn btn-sm btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800"
        >
          ยกเลิก
        </button> -->

        <button class="btn btn-sm btn-primary" data-testid="password-save" (click)="submit()">
          {{ "APP.SAVE_CHANGE" | translate }}
        </button>
      </div>
    </div>
    <div class="separator my-4"></div>

    <section class="col-12 pt-4" [formGroup]="form">
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap mb-4"
      >
        <h1
          class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-2"
        >
          {{ "APP.CHANGE_PASSWORD" | translate }}
        </h1>
      </div>
      <div class="row g-6 mb-8">
        <div class="col-12 col-sm-6 mt-2">
          <app-input
            label="APP.OLD_PASSWORD"
            name="old_password_field"
            type="password"
            formControlName="old_password"
            placeholder="APP.OLD_PASSWORD"
            [labelMode]="LabelMode.DEFAULT"
            [required]="true"
            [error]="error?.old_password"
            autocomplete="new-password"
          ></app-input>
        </div>
        <div class="col-12 col-sm-6 mt-2">
          <app-input
            label="APP.NEW_PASSWORD"
            name="new_password_field"
            type="password"
            formControlName="new_password"
            placeholder="APP.NEW_PASSWORD"
            [labelMode]="LabelMode.DEFAULT"
            [required]="true"
            [error]="error?.new_password"
            autocomplete="new-password"
          ></app-input>
        </div>
        <div class="col-12 col-sm-6 mt-2">
          <app-input
            label="APP.PASSWORD_CONFIRMATION"
            name="new_password_confirmation_field"
            formControlName="new_password_confirmation"
            type="password"
            placeholder="APP.PASSWORD_CONFIRMATION"
            [labelMode]="LabelMode.DEFAULT"
            [error]="error?.new_password_confirmation"
            autocomplete="new-password"
          ></app-input>
        </div>
      </div>
    </section>
    <div class="separator my-4"></div>

    <section>
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap mb-4 mt-6"
      >
        <h1
          class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-2"
        >
          {{ "APP.RESET_NEW_PASSWORD" | translate }}
        </h1>
      </div>
      <div>
        <!-- Tonal, not `btn-danger`. Asking for a reset link is not a
             destructive act, and a solid red bar was the loudest thing on a
             page whose actual primary action — "save my new password" — is a
             small button up in the header. Red here also spends the palette's
             one alarm colour on a routine request. -->
        <button
          class="btn btn-icon btn-light-primary w-auto p-1 px-4"
          (click)="resetRequest()"
        >
          <!-- An envelope, because the request arrives as mail. `loading`
               is a spinner glyph: rendered unconditionally it made an idle
               button look stuck mid-submit. -->
          <app-keenicon
            name="sms"
            class="fs-1 svg svg-icon me-2"
          ></app-keenicon>
          {{ "APP.SEND_REQ_PASSWORD" | translate }}
        </button>
      </div>
      <section class="d-flex flex-row fw-light mt-4 gap-1">
        <span class="">*</span>
        <div>
          <div class="fs-5 text-gray-800 lh-1">
            {{ "APP.PASSWORD_REQ_DESC1" | translate }}
          </div>
          <div class="fs-5 text-gray-800">
            {{ "APP.PASSWORD_REQ_DESC2" | translate }}
          </div>
        </div>
      </section>
    </section>
  </div>
  <!--end: Card Body-->
</div>
